/**
 * VitaGene Cart Enhancements
 * Interactive shipping estimation and real-time drawer updates.
 */

window.updateShippingEstimate = function(province) {
  if (!province) return;
  try {
    sessionStorage.setItem('vg_selected_province', province);
  } catch (e) {}

  const results = document.getElementById('CartShippingResults');
  if (!results) return;

  results.style.display = 'block';

  const pickupWc = results.querySelector('[data-tier="pickup-wc"]');
  const pickupGp = results.querySelector('[data-tier="pickup-gp"]');

  if (pickupWc) pickupWc.style.display = (province === 'WC') ? 'flex' : 'none';
  if (pickupGp) pickupGp.style.display = (province === 'GP') ? 'flex' : 'none';
};

// Dynamic Free Shipping Progress Bar Live Recalculator
window.updateFreeShippingBar = function(cart) {
  const bar = document.querySelector('.cart-shipping-bar');
  if (!bar || !cart) return;

  const threshold = parseInt(bar.dataset.threshold || '250000', 10);
  const total = cart.items_subtotal_price || cart.total_price || 0;
  const remaining = Math.max(0, threshold - total);
  const ratio = Math.min(100, (total / threshold) * 100);

  const fill = bar.querySelector('.cart-shipping-bar__fill');
  if (fill) {
    fill.style.width = ratio + '%';
    if (remaining <= 0) {
      fill.classList.add('cart-shipping-bar__fill--unlocked');
    } else {
      fill.classList.remove('cart-shipping-bar__fill--unlocked');
    }
  }
};

// Global Event Delegation: Never breaks across AJAX / Section Rendering replacements
document.addEventListener('change', (e) => {
  if (e.target && (e.target.id === 'CartShippingProvince' || e.target.matches('.cart-shipping-estimator__select'))) {
    window.updateShippingEstimate(e.target.value);
  }
});

// Auto-restore on initial load or AJAX refresh
function restoreSavedProvince() {
  try {
    const saved = sessionStorage.getItem('vg_selected_province');
    if (saved) {
      const select = document.getElementById('CartShippingProvince');
      if (select) {
        select.value = saved;
        window.updateShippingEstimate(saved);
      }
    }
  } catch (e) {}
}

document.addEventListener('DOMContentLoaded', restoreSavedProvince);
if (document.readyState !== 'loading') {
  restoreSavedProvince();
}


